import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import useTransitionStore from "../../../state/transitions";
import { useControls, folder } from "leva";
import AnimateCamera from "./AnimateCamera";
import { useThree } from "@react-three/fiber";
import shallow from "zustand/shallow";
import { isMobile, useMobileOrientation } from "react-device-detect";

function CameraTransitions() {
	const [
		CamIndex,
		CamPlacement,
		UpdateAssets,
		CameraMoveToHotspot,
		TriggerExitHotspot,
		CameraSide,
	] = useTransitionStore(
		(s) => [
			s.CamIndex,
			s.CamPlacement,
			s.UpdateAssets,
			s.CameraMoveToHotspot,
			s.TriggerExitHotspot,
			s.CameraSide,
		],
		shallow
	);

	const [cameraSettings, setCameraSettings] = useState(CamPlacement[0]);

	const { camera, controls } = useThree();
	//* Trigger Change of FOV ext=>int

	useEffect(() => {
		// if (camera.fov === CamPlacement[CamIndex].fov) return;
		if (isMobile) camera.fov = CamPlacement[CamIndex].mobileFov;
		else camera.fov = CamPlacement[CamIndex].fov;
		camera.updateProjectionMatrix();
	}, [UpdateAssets]);

	useEffect(() => {
		setCameraSettings(CamPlacement[CamIndex]);
	}, [CamIndex]);

	useEffect(() => {
		// const position = CamPlacement[CamIndex].position;
		// const target = CamPlacement[CamIndex].target;
		// if (CameraSide == "driver") {
		// 	position[2] = 1 - position[2]; // todo : needs better math. to avoid going through car when click in and out of hotspots or just have seperate cordinates in state for when one is passanger or driver.
		// 	target[2] = -target[2];
		// }
		// const cordinates = {
		// 	position: position,
		// 	target: target,
		// };
		// setCameraSettings(cordinates);
		setCameraSettings(CamPlacement[CamIndex]);
	}, [TriggerExitHotspot]);

	useEffect(() => {
		if (!CameraMoveToHotspot) return;
		// console.log(`cmh`, CameraMoveToHotspot.position);
		// const position = CameraMoveToHotspot.position;
		// const target = CameraMoveToHotspot.target;

		// if (CameraSide == "driver") {
		// 	position[2] = 1 - position[2];  // todo : needs better math. to avoid going through car when click in and out of hotspots or just have seperate cordinates in state for when one is passanger or driver.
		// 	target[2] = -target[2];
		// }

		// const cordinates = {
		// 	position: position,
		// 	target: target,
		// };

		// setCameraSettings(cordinates);
		setCameraSettings(CameraMoveToHotspot);
	}, [CameraMoveToHotspot]);

	const { isLandscape } = useMobileOrientation();

	const { position, target } = useControls({
		MoveCamera: folder({
			position: {
				value: { x: 5, y: 0, z: 5.9 },
				onChange: (value) => {
					camera.position.set(value.x, value.y, value.z);
					camera.updateProjectionMatrix();
				},
			},
		}),
	});

	return (
		<>
			<AnimateCamera
				position={
					isMobile && cameraSettings.mobilePosition
						? isLandscape && cameraSettings.landscapePosition
							? cameraSettings.landscapePosition
							: cameraSettings.mobilePosition
						: cameraSettings.position
				}
				target={cameraSettings.target}
			/>
		</>
	);
}

export default React.memo(CameraTransitions);
